// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RasterLayerStyle
 */
export interface RasterLayerStyle {
  /**
   *
   */
  id: string;
  /**
   *
   */
  minMax?: Array<any> | null;
}

/**
 * Check if a given object implements the RasterLayerStyle interface.
 */
export function instanceOfRasterLayerStyle(value: object): value is RasterLayerStyle {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function RasterLayerStyleFromJSON(json: any): RasterLayerStyle {
  return RasterLayerStyleFromJSONTyped(json, false);
}

export function RasterLayerStyleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterLayerStyle {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    minMax:
      json["min_max"] === undefined ? undefined : json["min_max"] === null ? null : json["min_max"],
  };
}

export function RasterLayerStyleToJSON(json: any): RasterLayerStyle {
  return RasterLayerStyleToJSONTyped(json, false);
}

export function RasterLayerStyleToJSONTyped(
  value?: RasterLayerStyle | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    min_max: value["minMax"],
  };
}
